import { render, staticRenderFns } from "./OWidgetWrapper.vue?vue&type=template&id=3f0e81cb&scoped=true&"
import script from "./OWidgetWrapper.vue?vue&type=script&lang=js&"
export * from "./OWidgetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./OWidgetWrapper.vue?vue&type=style&index=0&id=3f0e81cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e81cb",
  null
  
)

export default component.exports